// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import { jsonLightReadStringPropertyValue } from '@msdyn365-commerce/retail-proxy/dist/externals';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * CustomerEmailEntity entity interface.
 */

/**
 * AvaGetPrimaryProductInterestEntity entity class.
 */
export class AvaGetPrimaryProductInterestEntity {
    public primaryProductInterest: string;
    public ExtensionProperties: Entities.CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.primaryProductInterest = odataObject.primaryProductInterest;
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExtensionProperties = undefined;
        if (odataObject.ExtensionProperties) {
            this.ExtensionProperties = [];
            for (var i = 0; i < odataObject.ExtensionProperties.length; i++) {
                //   if (odataObject.ExtensionProperties[i] != null) {
                //   if (odataObject.ExtensionProperties[i]['@odata.type'] != null) {
                //   var className: string = odataObject.ExtensionProperties[i]['@odata.type'];
                //   className = className.substr(className.lastIndexOf('.') + 1).concat("Class");
                //   // @ts-ignore
                //   this.ExtensionProperties[i] = new Entities[className](odataObject.ExtensionProperties[i])
                //   } else {
                // //   this.ExtensionProperties[i] = new Entities.CommercePropertyClass(odataObject.ExtensionProperties[i]);
                //   }
                //               } else {
                //   this.ExtensionProperties[i] = undefined;
                //   }
            }
        }
    }
}
